<template>
  <div class="header">
    <el-dialog :title="disposeForm.title" :visible.sync="disposeForm.isOpen" width='450px' @close="disposeFormCancel"
      :close-on-click-modal='false' v-dialogDrag :modal-append-to-body='false'>
      <el-form ref="disposeForm" :model="disposeForm" label-width="100px">
        <div class="form-group row" v-for="(item,index) in disposeForm.data" :key="index">
          <!-- <label class="col-sm-2 col-form-label">{{index}}</label> -->
          <div v-if="$store.state.userRole=='施工'">
            <div class="col-sm-10" v-if="index=='overdue'||index=='notDisposedVolume'">
              {{item}}
            </div>
          </div>
          <div v-if="$store.state.userRole=='监理'">
            <div class="col-sm-10" v-if="index=='JL_check'||index=='JL_volume'">
              {{item}}
            </div>
          </div>
          <div v-if="$store.state.userRole=='第三方检测公司'">
            <div class="col-sm-10" v-if="index=='SF_check'||index=='SF_awaitCheck'">
              {{item}}
            </div>
          </div>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="info" @click="disposeFormCancel">关闭</el-button>
      </div>
    </el-dialog>
    <div class="header-left">
      <!-- <div class="logo">
        <img src="../assets/logo.png" />

      </div> -->
      <!-- <div class="triangle"></div> -->
      <!-- :disabled="messageList.length==0" -->
      <!-- <div style="display: inline-block;"></div> -->
      <img src="@/assets/西昆公司logo.png" height="50px" style="margin:0px 20px 0px 10px;">
      <div class="headerText">高铁隧道衬砌质量监测与管理数字化信息系统</div>
      <!--  <el-select v-model="test_userRole" @change="userChange" style="margin-left: 200px;">
        <el-option label="施工" value="施工"></el-option>
        <el-option label="监理" value="监理"></el-option>
        <el-option label="监理" value="监理"></el-option>
        <el-option label="第三方检测公司" value="第三方检测公司"></el-option>
      </el-select> -->
    </div>

    <div class="header-right">
      <div class="header-right-item">
        <img src="@/assets/header/header-user.png" />
        <span style="margin-right: 10px;">欢迎您 </span>
        <span style="margin-right: 5px;"> {{ $store.state.userAccount  }}</span>
        <span style="margin-right: 5px;">
          <el-button @click='logout' type="text">退出</el-button>
        </span>
      </div>
      <div class="header-right-item" style="position: relative;">
        <img src="@/assets/header/alarm1.png" style="width: 25px;height: 25px;cursor: pointer;" @click="openDialog" />
        <span
          style="position: absolute;background-color: #cc0003;padding: 3px 4px;border-radius: 10px;font-size: 12px;left: 15px;top: 0px;">{{count}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import VueEventBus from '@/model/VueEventBus'
  import {
    homeMessage,
    usersCount
  } from '@/common/api.js'
  export default {
    name: "Header",
    data() {
      return {
        count: 0,
        disposeForm: {
          title: '未处理信息',
          isOpen: false,
          data: []
        },
        test_userRole: this.$store.state.userRole,
        loginAccount: '',
        messageList: [],
      }

    },
    mounted() {
      this.getData()
    },
    methods: {
      openDialog() {
        this.disposeForm.isOpen = true
        this.getData()
      },
      getData() {
        usersCount({}).then((res) => {
          if (res.success) {
            if (res.data.length != 0) {
              this.disposeForm.data = res.data[0]
              let count = 0
              if (this.$store.state.userRole == '施工') {
                count = res.data[1].overdueCount + res.data[1].notDisposedVolumeCount
              } else if (this.$store.state.userRole == '监理') {
                count = res.data[1].JL_checkCount + res.data[1].JL_volumeCount
              } else if (this.$store.state.userRole == '第三方检测公司') {
                count = res.data[1].SF_checkCount + res.data[1].SF_awaitCheckCount
              }
              console.log(count);
              if (count < 99) {
                this.count = count
              } else {
                this.count = 99 + '+'
              }

            }
          }
        })
      },

      disposeFormCancel() {
        this.disposeForm.isOpen = false
      },
      logout() {
        sessionStorage.clear()
        this.$router.replace('/login')
      },

      getHomeMessage() {
        homeMessage({
          loginAccount: this.$store.state.userAccount
        }).then((res) => {
          if (res.success) {
            this.messageList = res.data
          }
        })
      },
      userChange(val) {
        console.log(val)
        this.$store.commit('setUserRole', val)
      }

    }
  }
</script>

<style scoped>
  .header {
    width: 100%;
    height: 70px;
    /* background-color: #1F3080; */
    background: linear-gradient(to right, #5AC6F7, #1F3080);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    z-index: 2000 !important;
  }

  .headerText {
    font-size: 27px;
    color: #FFFFFF;
  }

  .header-right {
    display: flex;
    color: #FFFFFF;
    margin-right: 30px;
  }

  .header-right-item {
    display: flex;
    margin-left: 30px;
    align-items: center;
  }

  .header-right-item img {
    width: 20px;
    height: 20px;
  }

  .header-right-item span {
    /* margin-left: 10px; */
    align-items: center;
    display: flex;

  }

  .informList {
    display: flex;
    align-items: center;
    justify-content: space-between;

    color: #000000;
    border-bottom: 1px solid #E8E8E8;
    margin-top: 10px;
  }

  .informList:hover {
    background-color: #BEBEBE;
    cursor: pointer;
  }

  .header-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 70px;
  }

  .logo {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 15px;
    background-color: #5481C0;
    padding-right: 20px;


  }

  .logo img {

    height: 60px;
    width: auto;
    /* margin-left: 5%; */

  }

  .triangle {
    border-style: solid;
    border-width: 35px 35px 35px 35px;
    border-color: transparent transparent #5481C0 transparent;
    width: 0px;
    height: 0px;

    transform: rotate(90deg);
  }

  .header>>>.dialog-footer {
    display: flex;
    justify-content: space-around;
    padding: 0px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue